import React, { useEffect, useRef } from 'react';
import { Line, LineOptions } from '@antv/g2plot';
import { transfer2LocalDate } from '../../../core/utils/timeFormat';
import BigNumber from 'bignumber.js';
import { RevenueItem } from '../../../domain/report-provider/chartProvider';
import _ from 'lodash';
import moment from 'moment';

export type RevenueChartProps = {
  dataSet: Array<RevenueItem>;
};

const NormalMchFeeChart = (props: RevenueChartProps) => {
  const ref = useRef<any>();
  const chartRef = useRef<Line>();

  const changeData = (data: Array<RevenueItem>) => {
    chartRef.current?.changeData(calculateChartData(data));
  };

  useEffect(() => {
    const rawData = props.dataSet;
    const chartData = calculateChartData(rawData);
    const config: LineOptions = {
      data: chartData,
      autoFit: true,
      xField: 'date',
      yField: 'value',
      seriesField: 'key',
      xAxis: {
        type: 'cat',
        label: {
          autoRotate: false,
          formatter: (v) => {
            return transfer2LocalDate(v);
          },
        },
      },
      yAxis: {
        grid: {
          line: {
            style: {
              lineWidth: 0.5,
            },
          },
        },
        label: {
          autoRotate: false,
          formatter: (v) => {
            return _.round(new BigNumber(v).toNumber(), 3);
          },
        },
      },
    };
    const line = new Line(ref.current, config);
    chartRef.current = line;
    line.render();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    changeData(props.dataSet);
  }, [props.dataSet]);

  return (
    <div>
      <div ref={ref} />
    </div>
  );
};

export default NormalMchFeeChart;

function calculateChartData(rawData: RevenueItem[]) {
  const result = [];
  for (const item of rawData) {
    const agentType = item.agentType;
    if (agentType !== 'NORMAL') {
      continue;
    }
    const date = transfer2LocalDate(item.reportDate);
    const systemId = item.systemId;
    const totalFee = new BigNumber(item.totalFee)
      .plus(new BigNumber(item.payforUsdtFee))
      .toNumber();
    result.push({
      timestamp: moment(date).valueOf(),
      date: date,
      value: totalFee,
      key: systemId,
    });
  }
  return _.sortBy(result, (item) => item.timestamp);
}
